/**
 * @file 文档页页面面包屑
 * @author Wanzhongyun
 */
import React from 'react';
import { Breadcrumb } from 'antd';
import { RightOutlined } from '@ant-design/icons';

import { IDocumentMenuItem } from '../../type.d';
import LinkA from '../../../../components/a/LinkA';

interface IProps {
    breadcrumbsList: IDocumentMenuItem[];
}

const DocBreadcrumb: React.FC<IProps> = props => {
    const breadcrumbsList = props.breadcrumbsList;

    return (
        <Breadcrumb className="paddle-doc-breadcrumb" separator={<RightOutlined />}>
            {breadcrumbsList.map(item => (
                <Breadcrumb.Item key={item.key}>
                    <LinkA to={item.link || ''}>{item.title}</LinkA>
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
};

export default DocBreadcrumb;
